import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import styles from "@/styles/Ui.module.scss"
import CloseBtn from "@/ui/CloseButton.tsx";
import clsx from "clsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {isMobile} from "react-device-detect";
import useCommon from "@/hooks/common.ts";


interface Props {
    children:React.ReactNode
    className?: string
    innerClassName?:string
    removeClose?:boolean
    open_state?:boolean
    on_close_state?():void
    onAfterOpen?():void
    onAfterClose?():void
    open: boolean
    id?:string
}

const ModalLayout:React.FC<Props> = (props) => {
    const {
        children,
        className,
        innerClassName,
        removeClose,
        on_close_state,
        open,
        onAfterOpen,
        onAfterClose,
        id
    } = props
    
    const [is_focused, set_is_focused] = useState(false)
    const {removeScrollability} = useCommon()
    const focused_handler = (x:boolean) => {
        set_is_focused(x)
    }
    
    useEffect(() => {
        
        if(open) {
            
            removeScrollability(open)
            
            if(window.innerWidth < 600 && isMobile) {
                eventEmitter.on(CommonClass.ModalEvents.FocusInputs, focused_handler)
            }
            
        } else {
            eventEmitter.off(CommonClass.ModalEvents.FocusInputs, focused_handler)
            removeScrollability(open)
        }
        
    }, [open])
    
    return (
        <Modal
            id={id&&id}
            isOpen={open}
            onRequestClose={() =>{
                if(typeof on_close_state === "function") {
                    on_close_state()
                }
            }}
            className={clsx(
                styles.standart_modal,
                is_focused && styles.is_focused,
                className && className
            )}
            ariaHideApp={false}
            onAfterOpen={() => {
                if(typeof onAfterOpen === "function") {
                    onAfterOpen()
                }
                
                const root =  document.getElementsByTagName('html')[0];
                root.setAttribute('style', 'overflow-y: hidden');
            }}
            onAfterClose={() => {
                if(typeof onAfterClose === "function") {
                    onAfterClose()
                }
                
                const root =  document.getElementsByTagName('html')[0];
                root.removeAttribute('style');
            }}
        >
            
            <div className={clsx(styles.inner, innerClassName  && innerClassName)}>
                {children}
            </div>
            
            {!removeClose && (
                <CloseBtn
                    className={styles.modal_close}
                    onClick={() => {
                        if(typeof on_close_state !== "function") return
                        on_close_state()
                    }}
                />
            )}
        </Modal>
    )
}

export default ModalLayout
